
CheckoutV2.Cart.SaveForLater.Item = function(checkout, cart) {
	var savedItem = this;

	this.$productContainer;
	this.productKey;
	this.$container;

	this.init = function() {
		savedItem.$productContainer = $('.saved-for-later .product-tiles');
	};

	this.add = function(item, productKey) {
		//console.log(item);
        var data        = item.data || item.item, // item.data (cart), item.item (sessionStorage / wishlist)
			options     = item.options || item.kitContents || []; // item.options (cart), item.kitContents (sessionStorage / wishlist)

		savedItem.options = options;
		savedItem.data = data;

		savedItem.productID = data.productID;
		savedItem.productPath = data.productPath;
		
		savedItem.productKey = productKey || cart.saveForLater.getProductKey(savedItem.productID, savedItem.data.pdk);
		cart.savedItems[savedItem.productKey] = savedItem;
		
		for (var k in savedItem.data) {
			if (k == 'mainImage') {
            	var prodImgSize = pointsBreak.getWidth() > 480 ? checkout.config.prodImgSize.small : 300;
            	savedItem.data.image = (prodImgSize !== undefined) ? CDNproduct + '/' + savedItem.data.mainImage + '_x'+prodImgSize+'.jpg' : CDNpath + '/img/bg_no-image_100x75.jpg';
			}
		}

		savedItem.setPrice(savedItem.data.unitprice, savedItem.data.price_retail, savedItem.data.availablePricing);

		savedItem.$productContainer.append(Jemplate.process('includes/partials/productTile.html', {section: 'saved', item: savedItem}));
		savedItem.afterDisplay();
	};
	
	this.setPrice = function(price, retail, availablePricing) {
		savedItem.unitprice = parseFloat(price).toMoney();
		savedItem.extendPrice();

		price  = parseFloat(price);
        retail = parseFloat(retail);

        if(price < retail) savedItem.saleDiscount(price, retail, availablePricing);
	};

	this.extendPrice = function() {
		savedItem.data.extendPrice = (savedItem.data.qty * savedItem.unitprice).toMoney();
	};

	this.saleDiscount = function(price, retail, availablePricing) {
        var discountPercentage = (retail - price) / retail * 100;
        // round the discount to the nearest percent
        discountPercentage = parseInt(discountPercentage + 0.5, 10);

        savedItem.data.pricecut = retail.toMoney();

        // Do not show the on sale text if this is a wholesale/manual price
        if(availablePricing
            && price != availablePricing.retail
            ) {
            return;
        }

        var saleText = "Sale";
        if(availablePricing.limitedQty) {
            saleText += " - Limited Qty";
        }
        else if(discountPercentage >= 10) {
			savedItem.data.discountPercentage = discountPercentage;
        }

		savedItem.data.labels = [saleText];
    };
	
	this.remove = function() {
		savedItem.$container.remove();
		delete cart.savedItems[savedItem.productKey];
	};
	
	this.changeQty = function(qty) {
		savedItem.data.qty = qty;
		savedItem.setPrice(savedItem.data.unitprice, savedItem.data.price_retail, savedItem.data.availablePricing);
		
		var prodImgSize = pointsBreak.getWidth() > 480 ? checkout.config.prodImgSize.small : 300;
		savedItem.data.image = (prodImgSize !== undefined) ? CDNproduct + '/' + savedItem.data.mainImage + '_x'+prodImgSize+'.jpg' : CDNpath + '/img/bg_no-image_100x75.jpg';
		
		savedItem.$container.replaceWith(Jemplate.process('includes/partials/productTile.html', {section: 'saved', item: savedItem}));
		savedItem.afterDisplay();
	}

	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			savedItem.$container.find('.loading-overlay .msg-text').html(loadingMsg);
			savedItem.$container.find('.loading-overlay').show();
			savedItem.clearMessages();
		} else {
			savedItem.$container.find('.loading-overlay').hide();
		}
	};

	this.error = function(errorMsg) {
		if (errorMsg) {
			savedItem.$container.find('.saved-item-error .msg-text').html(errorMsg);
			savedItem.$container.find('.saved-item-error').show();
		} else {
			savedItem.$container.find('.saved-item-error').hide();
			savedItem.$container.find('.saved-item-error .msg-text').html('');
		}
	};

	this.warning = function(warningMsg) {
		if (warningMsg) {
			savedItem.$container.find('.saved-item-warning .msg-text').html(warningMsg);
			savedItem.$container.find('.saved-item-warning').show();
		} else {
			savedItem.$container.find('.saved-item-warning').hide();
			savedItem.$container.find('.saved-item-warning .msg-text').html('');
		}
	};

	this.info = function(infoMsg) {
		if (infoMsg) {
			savedItem.$container.find('.saved-item-info .msg-text').html(infoMsg);
			savedItem.$container.find('.saved-item-info').show();
		} else {
			savedItem.$container.find('.saved-item-info').hide();
			savedItem.$container.find('.saved-item-info .msg-text').html('');
		}
	};
	
	this.clearMessages = function() {
		savedItem.error();
		savedItem.warning();
		savedItem.info();
	};
	
	this.afterDisplay = function() {
		savedItem.$container = $('#saved-item-'+savedItem.productKey);
	};
	
	this.disableLinks = function() {
		savedItem.$container.find('.moveToWishList, .js-wish-list-modal, .moveToCart, .removeSavedItem').css('pointer-events','none');
	};

	this.init();
};

